<!-- TODO: when updated on Angular 15, use the directive composition API and remove this container. -->
<div class="blur-container" #screwContainer>
  <!-- Configuration labels -->
  <div class="left-wrapper">
    @if (!showScrewsOnly && !exportingImage) {
      <div class="full-screen-container">
        @if (isInFullScreen) {
          <button mat-mini-fab (click)="toggleFullScreen()">
            <mat-icon>close</mat-icon>
          </button>
        }
        @if (isInFullScreen) {
          <button mat-raised-button color="accent-less" (click)="exportImage()" i18n>Als Bild exportieren</button>
        }
        @if (!fullscreenRef && !smallScreen) {
          <button mat-raised-button color="accent-less" (click)="toggleFullScreen()" i18n>Vollbildmodus</button>
        }
      </div>
    }

    @if (!showScrewsOnly) {
      <div
        #configurationLabelContainer
        class="configuration-label-container"
        [style.border-top]="getHiddenStatesIndicatorColor(ratioHiddenStateLabelsTop)"
        [style.border-bottom]="getHiddenStatesIndicatorColor(ratioHiddenStateLabelsBottom)"
        (scroll)="updateHiddenStateLabelRatios()"
      >
        @for (screwConfiguration of screwConfigurationProviders; track screwConfiguration; let configurationIndex = $index) {
          <div
            #configurationLabel
            class="configuration-label"
            [class.selected]="selectedProvider === configurationIndex"
            [class.highlighted]="highlightedConfigurationIndices.includes(configurationIndex)"
            (click)="onClickConfiguration(configurationIndex); $event.stopPropagation()"
            (mouseenter)="enableHighlightOnConfigurations([configurationIndex])"
            (mouseleave)="disableHighlightOnConfigurations()"
          >
            <div class="name-box dt-reserve-bold-width" data-cy="configuration-box" [attr.data-text]="screwConfiguration.name">
              @if (editedNameBoxIdx === configurationIndex) {
                <input
                  #nameBoxInput
                  class="alternative-name-input"
                  type="text"
                  [(ngModel)]="screwConfiguration.name"
                  (keyup.enter)="nameBoxInput.blur()"
                  dtAutoFocus
                />
              } @else {
                <div class="name-text">{{ screwConfiguration.name }}</div>
              }
            </div>
            @if (selectedProvider === configurationIndex) {
              <div
                class="indicator"
                #configurationLock
                matRipple
                [matRippleDisabled]="true"
                [matRippleRadius]="20"
                [matRippleUnbounded]="true"
              >
                @if (!isShiftPressed && !isSelectedConfigurationUnlocked) {
                  <mat-icon (click)="toggleLockOfSelectedConfiguration(); $event.stopPropagation()">lock</mat-icon>
                } @else {
                  <mat-icon (click)="toggleLockOfSelectedConfiguration(); $event.stopPropagation()">lock_open</mat-icon>
                }
              </div>
            } @else {
              <div
                class="indicator"
                [style.visibility]="highlightedConfigurationIndices.includes(configurationIndex) ? 'visible' : 'hidden'"
              >
                &bull;
              </div>
            }
          </div>
        }
        <div class="button-container">
          <button (click)="addAlternative(); $event.stopPropagation()" mat-button color="accent" data-cy="add-new-configuration"
            ><mat-icon>add_box</mat-icon><ng-container i18n>Alternative hinzufügen</ng-container></button
          >
          <button (click)="shufflePositions()" [disabled]="selectedProvider !== -1" mat-button color="accent"
            ><mat-icon>shuffle</mat-icon><ng-container i18n>Zufällige Auswahl</ng-container></button
          >
        </div>
      </div>
    }
  </div>
  <!-- Screws -->
  <div
    cdkDropList
    cdkDropListOrientation="horizontal"
    [cdkDropListAutoScrollStep]="10"
    (cdkDropListDropped)="moveScrew.emit([$event.previousIndex, $event.currentIndex])"
    class="screw-list"
  >
    @for (screw of screws; track screw; let screwIndex = $index; let last = $last) {
      <!-- Screw -->
      <div
        #screw
        class="screw"
        cdkDrag
        [class.editable]="!readonly"
        (cdkDragStarted)="isDraggingScrew = true"
        (cdkDragEnded)="isDraggingScrew = false"
        [cdkDragDisabled]="readonly"
      >
        <div
          cdkDragHandle
          class="header"
          #screwElement
          (click)="!readonly && editOrDeleteScrew.emit(screwIndex)"
          (dblclick)="dblClickedElement.emit([screw.name, screwElement])"
        >
          <dt-note-btn
            #noteBtn
            (click)="$event.stopPropagation()"
            [(comment)]="screw.comment"
            [caption]="screw.name | noteBtnPreset: 'screw'"
            [darkBackground]="true"
            [readonly]="readonly"
          >
            <ng-container
              additional-modal-content
              [ngTemplateOutlet]="noteBtnContent"
              [ngTemplateOutletContext]="{ $implicit: screw, noteBtn }"
            ></ng-container>
          </dt-note-btn>
          <div [attr.draggable]="!readonly" (dragstart)="dragStart($event, screw.name)" class="name-box">
            {{ screw.name }}
            @if (!screw.name) {
              <i i18n>Unbenannter Stellhebel</i>
            }
          </div>
        </div>
        @for (state of screw.states.concat(null); track state; let stateIndex = $index; let isNotDefinedState = $last) {
          <div
            class="state"
            #stateElement
            [class.not-defined]="isNotDefinedState"
            [class.highlighted]="isStateHighlighted(screwIndex, isNotDefinedState ? null : stateIndex)"
            [class.selected]="isStateSelected(screwIndex, isNotDefinedState ? null : stateIndex)"
            (mouseenter)="toggleHighlightOfConfigurationsGoingThroughState(screwIndex, isNotDefinedState ? null : stateIndex)"
            (mouseleave)="disableHighlightOnConfigurations()"
            (click)="clickState(screwIndex, isNotDefinedState ? null : stateIndex, $event)"
            [dtOverflow]="stateElement"
            [attr.draggable]="!readonly"
            (dragstart)="dragStart($event, state)"
          >
            <span class="name-box">
              @if (isNotDefinedState) {
                <i i18n>undefiniert</i>
              } @else {
                {{ state }}
                @if (!state) {
                  <i i18n>Position {{ stateIndex + 1 }}</i>
                }
              }
            </span>
          </div>
        }
      </div>
      <!-- State-state connections -->
      <div class="screw-connection-stripe">
        @if (!last && !showScrewsOnly) {
          <svg height="100%" [attr.width]="connectorStripeWidth" xmlns:svg="http://www.w3.org/1999/xhtml">
            @for (
              stateConnection of sortStateConnectionsByLevelOfHighlight(stateConnections[screwIndex]);
              track trackStateConnectionsByEndpoints($index, stateConnection)
            ) {
              <ng-container>
                <svg:path
                  class="screw-state-connection"
                  [attr.d]="leftRightConnectorToPathDefinition(stateConnection)"
                  [class.highlighted]="isStateConnectionHighlighted(stateConnection)"
                  [class.selected]="isStateConnectionSelected(stateConnection)"
                  (click)="$event.stopPropagation()"
                ></svg:path>
                <svg:path
                  (mouseenter)="enableHighlightOnConfigurations(stateConnection.configurationIndices)"
                  (mouseleave)="disableHighlightOnConfigurations()"
                  (click)="scrollConfigurationLabelIntoView(stateConnection.configurationIndices[0]); $event.stopPropagation()"
                  [attr.d]="leftRightConnectorToPathDefinition(stateConnection)"
                  class="screw-state-connection-highlight-area"
                ></svg:path>
              </ng-container>
            }
          </svg>
        }
      </div>
    }
  </div>
  @if (!showScrewsOnly) {
    <button class="screw-append-button" mat-icon-button color="accent" (click)="appendScrew.emit()" [disabled]="readonly">
      <mat-icon>add</mat-icon>
    </button>
  }
</div>
